/**
 * ES Sticky UI Controller
 * - Replaces multiple inline jQuery scroll handlers with one lightweight controller
 * - Uses passive scroll + requestAnimationFrame throttling (better INP / less jank)
 * - Preserves the original visual logic for:
 *   - sticky_addcart (PDP)
 *   - menu_toolbar (mobile)
 *   - popup-cookie + popup_random_prod bottom positioning
 */
(function () {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  var sticky = qs('.sticky_addcart');
  var popupRandom = qs('.popup_random_prod');
  var popupCookie = qs('.popup-cookie');
  var toolbar = qs('.menu_toolbar');
  var gotItButtons = qsa('.got_it');

  var isProduct = document.body && document.body.classList.contains('template-product');

  // Provide a reliable header height CSS variable for sticky layouts (PDP right column, etc.)
  function setHeaderHeightVar() {
    var headerEl =
      qs('#shopify-section-header') ||
      qs('header') ||
      qs('.site-header') ||
      qs('.header');
    if (!headerEl) return;
    var h = headerEl.getBoundingClientRect().height || headerEl.offsetHeight || 0;
    if (h > 0) {
      document.documentElement.style.setProperty('--es-header-h', Math.round(h) + 'px');
    }
  }

  function isCookieVisible() {
    if (!popupCookie) return false;
    return !popupCookie.classList.contains('d-none');
  }

  function setBottom(el, px) {
    if (!el) return;
    el.style.bottom = px + 'px';
  }

  function setActive(el, active) {
    if (!el) return;
    el.classList.toggle('active', !!active);
  }

  var ticking = false;
  var lastY = 0;

  function update() {
    ticking = false;

    var w = window.innerWidth || document.documentElement.clientWidth || 1024;
    var y = lastY;

    // Desktop PDP behavior
    if (isProduct && w > 1024) {
      var activeDesktop = y >= 100;
      setActive(sticky, activeDesktop);
      setActive(popupRandom, activeDesktop);
      setActive(popupCookie, activeDesktop);
      return;
    }

    // Mobile behaviors
    if (w < 577) {
      var cookieVisible = isCookieVisible();

      if (isProduct) {
        // PDP mobile
        if (y >= 300) {
          setActive(sticky, true);
          setActive(toolbar, true);
          setBottom(popupCookie, 114);
          setBottom(popupRandom, cookieVisible ? 323 : 114);
        } else {
          setActive(toolbar, false);
          setActive(sticky, false);
          setBottom(popupCookie, 0);
          setBottom(popupRandom, cookieVisible ? 208 : 0);
        }
      } else {
        // Non-PDP mobile
        if (y >= 300) {
          setActive(toolbar, true);
          setBottom(popupCookie, 50);
          setBottom(popupRandom, cookieVisible ? 258 : 50);
        } else {
          setActive(toolbar, false);
          setBottom(popupCookie, 0);
          setBottom(popupRandom, cookieVisible ? 208 : 0);
        }
      }

      return;
    }

    // Cleanup on desktop/tablet
    setActive(toolbar, false);
    if (isProduct) {
      setActive(sticky, false);
    }
    if (popupCookie) popupCookie.style.bottom = '';
    if (popupRandom) popupRandom.style.bottom = '';
  }

  function onScroll() {
    lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function onResize() {
    setHeaderHeightVar();
    lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    update();
  }

  // Initial
  lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  setHeaderHeightVar();
  update();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

  // Cookie dismissal button
  if (gotItButtons && gotItButtons.length) {
    gotItButtons.forEach(function (btn) {
      btn.addEventListener(
        'click',
        function () {
          // Cookie element may toggle .d-none async; wait one tick.
          window.setTimeout(function () {
            lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
            update();
          }, 0);
        },
        { passive: true }
      );
    });
  }
})();
